import { useCallback } from 'react'
import { graphql, useMutation } from 'react-relay'

import {
  type useRemoveUserPushTokenMutation as UseRemoveUserPushTokenMutation,
  type useRemoveUserPushTokenMutation$data
} from '@/__generated__/useRemoveUserPushTokenMutation.graphql'

type CommitAsyncFn = (token: string) => Promise<useRemoveUserPushTokenMutation$data>

export const useRemoveUserPushTokenMutation = (): [CommitAsyncFn, boolean] => {
  const [commit, isPending] = useMutation<UseRemoveUserPushTokenMutation>(graphql`
    mutation useRemoveUserPushTokenMutation($input: RemoveUserPushTokenInput!) {
      removeUserPushToken(input: $input) {
        user {
          isPushNotificationsEnabled
          updatedAt
        }
      }
    }
  `)

  const commitAsync = useCallback<CommitAsyncFn>(
    (token: string) =>
      new Promise<useRemoveUserPushTokenMutation$data>((resolve, reject) =>
        commit({
          onCompleted: (response, errors) => {
            if (errors) {
              reject(errors)
            } else {
              resolve(response)
            }
          },
          // transport-level failures (offline, 5xx, WS drop) invoke onError, not onCompleted — without
          // this the promise would never settle and isEnablingNotifications would stay stuck on.
          onError: (error) => reject(error),
          variables: {
            input: {
              token
            }
          }
        })
      ),
    [commit]
  )

  return [commitAsync, isPending]
}
